import { WidgetKind, type Report, type TimeField } from 'corso-admin-ui';

const timeFields = [
  'finalizedOn',
  'deliveredOn',
  'createdOn',
] as const satisfies TimeField<'claimItems'>[];

export const items = {
  key: 'items',
  label: 'Items',
  dataset: 'claimItems',
  timeFields,
  widgets: [
    { kind: WidgetKind.kpi, title: 'Quantity', metric: 'items' },
    { kind: WidgetKind.kpi, metric: 'labelCost' },
    {
      kind: WidgetKind.kpi,
      title: 'Original item price',
      metric: 'itemValue',
    },
    {
      kind: WidgetKind.kpi,
      title: 'Original item cost',
      description: "At each product's current cost",
      metric: 'itemCost',
    },
    {
      kind: WidgetKind.list,
      title: 'Returned items',
      list: 'claimItems',
      timeFields,
      columns: [
        { column: 'orderNumber', title: 'Order' },
        { column: 'orderedOn', title: 'Ordered' },
        { column: 'createdOn', title: 'Created' },
        { column: 'finalizedOn', title: 'Finalized' },
        { column: 'deliveredOn', title: 'Delivered' },
        { column: 'productTitle', title: 'Product' },
        { column: 'sku', title: 'SKU' },
        { column: 'quantity', title: 'Quantity' },
        { column: 'reason', title: 'Reason' },
        { column: 'resolution', title: 'Resolution' },
      ],
    },
  ],
} as const satisfies Report;
